import {Coordinates} from "@/modules/Rhizome/interfaces/coordinates.interface";

export class CoordinatesJsService {
  public x: number = 0;
  public y: number = 0;
  private centerCoords = {
    left: 0,
    top: 0,
  };
  private viewType = Coordinates.ViewType.cloud;
  private index = 0;

  constructor(configs: Coordinates.IConfigs) {
    this.centerCoords = configs.centerCoords;
    this.viewType = configs.viewType;
    this.index = configs.index;

    this.calculateCoordinates();
  }

  private calculateCoordinates() {
    switch (this.viewType) {
      case Coordinates.ViewType.cloudStatic:
        this.getCloudCoordinates(55);
        break;

      case Coordinates.ViewType.cloud:
      default:
        this.getCloudCoordinates(120);
        break;
    }
  }

  private getCloudCoordinates(cloudSize: number) {
    let a = this.index * 137.5;
    let r = cloudSize * Math.sqrt(this.index);
    let x = r * Math.cos(a * (Math.PI / 180)) + (this.centerCoords.left);
    let y = r * Math.sin(a * (Math.PI / 180)) + (this.centerCoords.top);

    this.x = x;
    this.y = y;
  }
}
